import React from 'react';
import { IRewardCoinTip } from 'mod/cart/interface'
import Image from '@base/lib/ThemeImage';
import cn from 'classnames';
import styles from './index.module.less';
import RewardCoinsItem from '@base/activity/redeemRewards/RewardCoinsItem'


type IProps = {
    data: IRewardCoinTip
}

const RewardCoinTip: React.FC<IProps> = (props) => {
    const {
        data
    } = props

    return !data ? null : (
        <div className={cn(styles['reward-coin-tips'],'flex flex-justify')}>
            <div className={cn(styles.title, 'flex-1')}>
                {data.title}
            </div>
            <div className={'flex'}>
                {data.rewardCoins?.map((item) => {
                    return (
                        <RewardCoinsItem
                            className={cn(styles['reward_item'], 'flex flex-middle')}
                            iconUrl={item.icon}
                            num={(<>
                                <span className={cn({[styles['waring']]: +item.cartCoinNum > +item?.num})}>
                                    {item.cartCoinNum}
                                </span>/{item?.num}
                            </>)}
                        />
                    )
                })}
            </div>
        </div>
    );
};

export default RewardCoinTip